module.exports = __webpack_public_path__ + "img/about-3.64b29d63.jpg";